var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Players-Added-(Mobile)",
    transform: "translate(-98.000000, -226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Go_arrow",
    transform: "translate(98.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_arrow-forward_2459676",
    transform: "translate(0.500000, 2.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45055915,0.236261642 L8.93309855,2.8134753 C9.00619916,2.87289141 9.06034375,2.95526103 9.08516565,3.05031413 C9.11064565,3.14788741 9.10275847,3.24945315 9.06303656,3.34545969 L9.06303656,3.34545969 L9.05172194,3.36843678 C9.0450861,3.38351998 9.0367481,3.39834274 9.02350594,3.41844119 L9.02350594,3.41844119 L9.01683225,3.42722687 L8.96819832,3.48640592 L6.19957559,6.30037012 C6.11579794,6.38573088 6.00196333,6.43348922 5.88350766,6.43333304 C5.79307824,6.43333304 5.70708286,6.40569193 5.63505507,6.35677151 C5.56341849,6.30811678 5.50559567,6.23839131 5.47117084,6.15391271 C5.43688593,6.06977748 5.42920538,5.97928897 5.44595163,5.8937334 C5.46273451,5.80799067 5.50403949,5.72723232 5.56751071,5.66272405 L5.56751071,5.66272405 L7.57739115,3.61900895 L0.346088686,3.61928025 C0.222721317,3.61928025 0.110956943,3.56858419 0.0300843923,3.4863872 C-0.0502049998,3.40478291 -0.1,3.29208465 -0.1,3.16752369 C-0.1,3.04296273 -0.0502049998,2.93026447 0.0300843923,2.84866019 C0.110956943,2.76646319 0.222721317,2.71576713 0.346078416,2.71576713 L0.346078416,2.71576713 L7.57734407,2.71502451 L5.56801631,0.672847826 C5.45469637,0.559264202 5.40970995,0.392689771 5.45055915,0.236261642 L5.45055915,0.236261642 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoArrow);
export default __webpack_public_path__ + "static/media/go-arrow.e5b005ca3ca2df15aafe94173354224b.svg";
export { ForwardRef as ReactComponent };